import type { ComponentType } from "react";
import {
  MailIcon, CalendarIcon, DocuParserIcon, FilesIcon, EngageIcon,
  DeckorateIcon, QueueIcon, TranscribeIcon, KnowledgeIcon, ReviewIcon,
} from "../shared/components/icons";

export type HostName = "Outlook" | "Word" | "PowerPoint";

export interface ModuleDefinition {
  id: string;
  name: string;
  subtitle: string;
  icon: ComponentType;
  iconGradient: [string, string];
  hosts: HostName[];
}

export type NbaFilter = "all" | "outstanding" | "completed";

export const ALL_MODULES: ModuleDefinition[] = [
  { id: "docuparser", name: "DocuParser",  subtitle: "PDF → Word",            icon: DocuParserIcon, iconGradient: ["#1A9E8F", "#147F73"], hosts: ["Outlook", "Word"] },
  // AIVA-6249: this tile is the add-in's File Management surface and is now
  // labelled "Document Management" to match the Studio module of the same name
  // (see BACKEND_MODULE_TILE_ALIASES, which still maps that module → this tile's
  // id). Its FilesModule carries both OneDrive and SharePoint tabs — reflected in
  // the subtitle — so OneDrive is no longer a separate tile.
  { id: "files",      name: "Document Management", subtitle: "OneDrive & SharePoint", icon: FilesIcon, iconGradient: ["#004E97", "#0B5DAA"], hosts: ["Outlook", "Word", "PowerPoint"] },
  // AIVA-6249: labelled "Email Management" to match the Studio module name.
  { id: "email",      name: "Email Management", subtitle: "Triage",           icon: MailIcon,       iconGradient: ["#D32F2F", "#B71C1C"], hosts: ["Outlook"] },
  { id: "calendar",   name: "Calendar Management",subtitle: "Schedule",              icon: CalendarIcon,   iconGradient: ["#F5A623", "#D88A0E"], hosts: ["Outlook"] },
  { id: "knowledge",  name: "Knowledge Base",subtitle: "SOPs & Precedents",     icon: KnowledgeIcon,  iconGradient: ["#784590", "#5C3370"], hosts: ["Outlook", "Word", "PowerPoint"] },
  { id: "review",     name: "Review",     subtitle: "Doc Analysis",          icon: ReviewIcon,     iconGradient: ["#A63D7D", "#7E2A5E"], hosts: ["Outlook", "Word"] },
  { id: "transcribe", name: "Transcribe", subtitle: "Audio",                 icon: TranscribeIcon, iconGradient: ["#1A9E8F", "#147F73"], hosts: ["Outlook", "Word"] },
  { id: "engage",     name: "Engage",     subtitle: "Jobs",                  icon: EngageIcon,     iconGradient: ["#1A9E8F", "#147F73"], hosts: ["Outlook"] },
  { id: "deckorate",  name: "Deckorate",  subtitle: "Slide Design",          icon: DeckorateIcon,  iconGradient: ["#FF5600", "#F5A623"], hosts: ["PowerPoint"] },
  { id: "myqueue",    name: "MyQueue",    subtitle: "Task Queue",            icon: QueueIcon,      iconGradient: ["#1A9E8F", "#147F73"], hosts: ["Outlook", "Word", "PowerPoint"] },
];
